import {Font, StyleSheet} from "@react-pdf/renderer";

Font.register({
    family: 'HelveticaBold',
    fonts: [
        {
            src: '/fonts/HelveticaNeueLTStd-Bd.woff',
            fontWeight: 700,
        },
    ],
});
export const productStyleSheet = {
    p : {
        fontSize: 10,
    },
    h2: {
        fontSize: 24,
        lineHeight: 1.25,
    },
    h3: {
        fontSize: 22,
        lineHeight: 1.25,
    },
    h4: {
        fontSize: 20,
        lineHeight: 1.25,
    }
};

export const giftCertificateStyle = StyleSheet.create({
    backgroundContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
    backgroundImage: {
        width: '100%',
        height: '100%',
    },
    body: {
        flexDirection: 'column',
        paddingTop: '57%',
        paddingRight: '35%',
        paddingLeft: '10%',
        fontSize: 12,
        lineHeight: 1.5,
    },
    productBody: {
        flexDirection: 'column',
        paddingTop: '57%',
        paddingRight: '20%',
        paddingLeft: '10%',
        fontSize: 12,
        lineHeight: 1.5,
    },
    title: {
        fontSize: 42,
        fontFamily: 'HelveticaBold',
        bottom: -10,
    },
    productTitle: {
        fontSize: 39,
        fontFamily: 'HelveticaBold',
        bottom: -20,
    },
    productContent: {
        height: 250,
        top: 4,
    },
    content: {
        height: 250,
    },
    description: {
        fontSize: 11,
    },
    productDescription: {
        fontSize: 12,
    },
    personalGreeting: {
        fontSize: 11,
        top: 10,
    },
    product: {
        display: 'flex',
        flexDirection: 'row',
        top: 15,
    },
    productInfo: {
        fontSize: 8.5,
        left: 15,
        width: 300,
        top: 5,

    },
    productIcon: {
        width: 30,
        height: 30,
        top: 15,
    },
    binder: {
        fontSize: 8.5,
        top: 25,
    },
});